import React, { useState, useEffect } from 'react';
import cssClasses from './QueueBlocks.module.css';
import Search from '../../Subcomponents/Search';
import { Box } from '@mui/material';
import StatusChip from '../LeadStatusChip';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { useSelector } from 'react-redux';
export default function QueueBlocks({
  group,
  handleChange,
  grpIndex,
  leadData,
}) {
  const [groupTokenSearch, setGroupTokenSearch] = useState('');
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  useEffect(() => {
    console.log(group);
  }, []);

  return (
    <div className={cssClasses.cardWrapper}>
      <div className={cssClasses.cardHeader}>
        <p>{group.tokenName}<span style={{marginLeft:"1rem"}}>{(group?.leads !== null &&
          group?.leads?.length > 0)?group?.leads.length:0}</span></p>
        <div>
          <Search
            sxStyle={{
              ' .MuiInputBase-root': {
                background: '#FFFFFF !important',
              },
            }}
            id={'tokenHoldersSearch'}
            search={(e) => {
              console.log(e.target.value);
              setGroupTokenSearch(e.target.value);
            }}
            placeholder={'Search here...'}
            width={'18rem'}
          />
        </div>
      </div>
      <div className={cssClasses.cardContentContainer}>
        {group?.leads !== null &&
          group?.leads?.length > 0 &&
          group?.leads
            .filter((lead, index) => {
              if (groupTokenSearch !== '') {
                var numbers = new RegExp('^[0-9]*$');
                var alphabets = new RegExp('^[a-zA-Z ]*$');
                if (alphabets.test(groupTokenSearch)) {
                  return lead.leadName
                    ?.toLowerCase()
                    .includes(groupTokenSearch?.toLowerCase());
                } else if (groupTokenSearch.includes('VJ')) {
                  // const searching = groupTokenSearch.slice(2).split('-').join('');
                  return lead.displayId
                    ?.toLowerCase()
                    .includes(groupTokenSearch?.toLowerCase());
                } else if (numbers.test(groupTokenSearch)) {
                  return lead.tokenNumber?.includes(groupTokenSearch);
                } else {
                  return lead.displayId
                    ?.toLowerCase()
                    .includes(groupTokenSearch?.toLowerCase());
                }
              } else {
                return true;
              }
            })
            .map((lead, index) => {
              return (
                <div
                  className={cssClasses.cardContent}
                  key={`CheckPoint_${index + 1}`}
                >
                  <div className={cssClasses.cardTextWrapper}>
                    <p className={cssClasses.leadNameText}>
                      <span>{index + 1}.</span> {lead?.leadId?.personId?.name}
                    </p>
                    <p className={cssClasses.cardText}>
                      <span>CP: </span>
                      {lead?.leadId?.cpId?.billingName
                        ? lead?.leadId?.cpId?.billingName
                        : '-'}
                    </p>
                    <p className={cssClasses.cardText}>VJ{lead.tokenNumber}</p>
                    <p className={cssClasses.cardText}>
                      <span>SM:</span>
                      {lead.leadId.userId.name ?? '-'}
                    </p>
                    <p className={cssClasses.cardText}>
                      <span>Band Number:{lead.displayBandNumber ?? '-'}</span>
                    </p>
                    <Box
                      display={'flex'}
                      flexDirection={'row'}
                      gap={'1rem'}
                      alignItems={'center'}
                      flex={'0 0 100%'}
                    >
                      {lead?.leadId?.LeadStatus[0]?.status ===
                        'Token Payment Complete' && (
                        <StatusChip
                          style={{
                            color: '#3538CD',
                            backgroundColor: 'rgb(238, 244, 255)',
                          }}
                          label={lead?.leadId?.LeadStatus[0]?.status}
                        />
                      )}
                      {lead?.leadId?.LeadStatus[0]?.status ===
                        'Checkpoint One Cleared' && (
                        <StatusChip
                          style={{
                            color: '#6941C6',
                            backgroundColor: '#F4EBFF',
                          }}
                          label={lead?.leadId?.LeadStatus[0]?.status}
                        />
                      )}
                      {lead?.leadId?.LeadStatus[0]?.status ===
                        'Checkpoint Two Cleared' && (
                        <StatusChip
                          style={{
                            color: '#0E7090',
                            backgroundColor: '#ECFDFF',
                          }}
                          label={lead?.leadId?.LeadStatus[0]?.status}
                        />
                      )}

                      <p className={cssClasses.cardText}>
                        <span>{lead.displayId}</span>
                      </p>
                    </Box>
                  </div>
                  {/* loggedInUser?.roleId?.accessibleTabs?.Queue["Token Wise"]["Token Name"]["Token Forward"]?.isAccessible && */}
                  {(lead?.checkpt1 === false ||
                    (lead?.checkpt1 && lead?.bandNumber !== null)) && (
                    <div className={cssClasses.cardButtonWrapper}>
                      <button
                        className={cssClasses.CardArrowButton}
                        onClick={() => {
                          console.log(lead);
                          // setCheckPoint(1);
                          handleChange(lead);
                          document.getElementById(
                            'input-with-icon-textfield tokenHoldersSearch'
                          ).value = '';
                          // setQrPresent(false);
                          // setScanConformationModal(true);
                        }}
                      >
                        <KeyboardDoubleArrowRightIcon
                          style={{ width: '2rem', height: '2rem' }}
                        />
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
      </div>
    </div>
  );
}
